import React from "react";
import ConfigurationBoutique from "./ConfigurationBoutique";
// Le même formulaire conserve sa saisie lors d'un changement de largeur.
export default function ResponsiveConfigurationBoutique() { return <ConfigurationBoutique />; }
